import Address from "@/api/Address";

export class OrderShippingDTO {
    public methodId?: string;
    public methodTitle?: string;
    public cost = 0;
    public address?: Address;
}

export default class OrderShipping extends OrderShippingDTO {
    constructor(dto: OrderShippingDTO) {
        super();
        Object.assign(this, dto);
        if (this.address != undefined) {
            this.address = new Address(this.address);
        }
    }
}